import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../../auth/services/auth.service';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { Router } from '@angular/router';

export const AuthInterceptorFn: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (
    req.url.includes('/refresh') ||
    req.url.includes('/login') ||
    req.url.includes('/survey/') ||
    req.url.includes('/NextStep') ||
    req.url.includes('/ConfirmStep') ||
    req.url.includes('/PreviousStep') ||
    req.url.includes('/ProcessRespondentLink') ||
    req.url.includes('/SaveResponse')
  ) {
    return next(req);
  }

  const token = authService.getToken();
  if (token) {
    const expDate = authService.decodeToken(token)?.exp;
    if (expDate) {
      const isExpired = expDate * 1000 < Date.now();

      if (isExpired) {
        const refreshToken = authService.getRefreshToken();
        if (refreshToken) {
          return authService.refresh(refreshToken).pipe(
            switchMap((response) => {
              const newToken = authService.getToken();
              const clonedRequest = req.clone({
                setHeaders: { Authorization: `Bearer ${newToken}` },
              });
              return next(clonedRequest);
            }),
            catchError((error) => {
              console.error('Refresh token failed:', error);
              authService.removeTokenInfo();
              router.navigate(['/login']);
              return throwError(() => new Error('Refresh failed'));
            }),
          );
        } else {
          authService.removeTokenInfo();
          router.navigate(['/login']);
          return throwError(() => new Error('No refresh token'));
        }
      } else {
        const clonedRequest = req.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        });
        return next(clonedRequest);
      }
    }
  }

  authService.removeTokenInfo();
  router.navigate(['/login']);
  return throwError(() => new Error('No token'));
};
